export { default as DiagnosticsPane } from './components/DiagnosticsPane';
export { default as MiniMavenPane } from './components/MiniMavenPane';
export { default as FeatureFlagsHeader } from './components/FeatureFlags/FeatureFlagsHeader';
export { default as FeatureFlagsList } from './components/FeatureFlags/FeatureFlagsList';

import './orchestrators/featureFlagsPaneOrchestrators';
import './mutators/featureFlagsPaneMutators';

// Register owa-time-panel's orchestrator to launch the timepanel before we start the header pane
import 'owa-time-panel/lib/orchestrators/timePanelBootstrapOrchestrators';
